import { WidgetRoot } from './components/WidgetRoot';

export default WidgetRoot;
